import { ChatBubbleOvalLeftIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useCreationChat } from '../../layouts/PatientCreationLayout';
import { usePatientMetadata } from '../../providers/PatientMetadataProvider';

const MessageOdoFooterButton: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const { openChat } = useCreationChat();
    const { hasUnreadMessages } = usePatientMetadata();

    if (!id) {
        return null;
    }

    return (
        <button
            type="button"
            onClick={openChat}
            className="relative shrink-0 flex items-center gap-1.5 bg-white text-gray-800 border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors font-semibold text-sm"
        >
            <ChatBubbleOvalLeftIcon className="w-4 h-4" />
            Message ODO
            {hasUnreadMessages(id) && (
                <span
                    aria-label="Unread messages"
                    className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-red-500 ring-2 ring-white"
                />
            )}
        </button>
    );
};

export default MessageOdoFooterButton;
